<template>
  <div v-if="modulesObject.length > 0 && loader === false">
    <app-collapse
      v-for="object in modulesObject"
      :key="object.id"
      accordion
    >
      <app-collapse-item
        v-if="object.module_id === 1 && object.depends_on === moduleObjectId"
        :title="'Await: '+object.module_settings.number_of_days+' day(s)'"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_TYPE') }} : {{ object.module_settings.type === 1 ? 'Time Based' : 'Action Based' }}
              </b-list-group-item>
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_DAYS') }} : {{ object.module_settings.number_of_days }}
              </b-list-group-item>
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_SKIP_WEEKEND') }} : {{ object.module_settings.skip_monday ? $t('DEBTIA_YES') : $t('DEBTIA_NO') }}
              </b-list-group-item>
              <b-list-group-item
                class="main-items"
              >
                {{ $t('DEBTIA_AWAIT_SKIP_INTEREST') }} : {{ object.module_settings.skip_interest_calculation ? $t('DEBTIA_YES') : $t('DEBTIA_NO') }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="(object.module_id === 2 || object.module_id === 14) && object.depends_on === moduleObjectId"
        title="Condition Module"
        class="nested-condition-module nested-module"
      >
        <b-list-group
          flush
          class="awaitlist"
        >
          <b-list-group-item>
            {{ $t('DEBTIA_CONDITION') }} : {{ getConditionStatement(object.module_settings.condition_id) }}
            <small
              v-if="object.module_settings.statements"
            >
              ({{ object.module_settings.statements }})
            </small>
          </b-list-group-item>
          <b-list-group-item
            v-if="object.module_settings.condition_operator_id < 3"
          >
            {{ $t('DEBTIA_OPERATOR') }} : {{ object.module_settings.condition_operator_id === 1 ? $t('DEBTIA_TRUE_TEXT') : $t('DEBTIA_FALSE_TEXT') }}
          </b-list-group-item>
          <b-list-group-item
            v-else
          >
            {{ $t('DEBTIA_OPERATOR') }} : {{ object.module_settings.statementOperator }}
          </b-list-group-item>
          <b-list-group-item
            v-if="object.module_settings.client_type"
          >
            {{ $t('DEBTIA_CLIENT_TYPE') }} : {{ object.module_settings.client_type === 'person' ? 'Person' : (object.module_settings.client_type === 'sole-proprietorship' ? $t('DEBTIA_SOLE_PROPRIETORSHIP') : (object.module_settings.client_type === 'capital-company' ? $t('DEBTIA_CAPITAL_COMPANY') : object.module_settings.client_type)) }}
          </b-list-group-item>
          <b-list-group-item
            v-if="object.module_settings.field"
          >
            {{ object.module_settings.field.label }} : {{ object.module_settings.condition_id === 10 ? $t(object.module_settings.field.value) : object.module_settings.field.value }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_AWAIT_SKIP_MONDAY') }} : {{ object.module_settings.skip_monday ? $t('DEBTIA_YES') : $t('DEBTIA_NO') }}
          </b-list-group-item>
        </b-list-group>
        <b-button
          variant="relief-primary"
          class="expand-btn"
          @click="expandCondition(object.id)"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
            class="expand-feather"
          /> {{ $t('DEBTIA_EXPAND') }}
        </b-button>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 25 && object.depends_on === moduleObjectId"
        title="Content Condition Module"
        class="nested-condition-module nested-module"
      >
        <b-list-group
          flush
          class="awaitlist"
        >
          <!-- <b-list-group-item>
            {{ $t('DEBTIA_TIMED') }} : {{ object.module_settings.is_timed ? $t('DEBTIA_YES') : $t('DEBTIA_NO') }}
          </b-list-group-item> -->
          <b-list-group-item
            v-if="object.module_settings.is_timed && object.module_settings.days !== null"
          >
            {{ $t('DEBTIA_DAYS') }} : {{ object.module_settings.days }}
          </b-list-group-item>
          <b-list-group-item
            v-for="(row, rowIndex) in object.module_settings.rules"
            :key="rowIndex"
          >
            {{ $t('DEBTIA_FILE_CATEGORIES') }}: {{ row.file_category }}
            | {{ $t('DEBTIA_OPERATOR') }}: {{ row.operator }}
            <!-- | {{ $t('DEBTIA_CUSTOM_FIELD') }}: {{ row.threshold }} -->
            <!-- <span v-if="row.value_type === 'literal'">
              | {{ $t('DEBTIA_NUMBER_OF_DAYS') }}: {{ row.threshold }}
            </span>
            <span v-if="row.value_type === 'custom_variable'">
              | {{ $t('DEBTIA_CUSTOM_VARIABLE') }}: {{ row.threshold }} ({{ $t('DEBTIA_CUSTOM_FIELD') }})
            </span> -->
            <span>
              | {{ $t('DEBTIA_NUMBER_OF_UPLOADS') }}: {{ row.threshold }}<span v-if="row.value_type === 'custom_variable'"> ({{ $t('DEBTIA_CUSTOM_FIELD') }})</span>
            </span>
          </b-list-group-item>
        </b-list-group>
        <b-button
          variant="relief-primary"
          class="expand-btn"
          @click="expandCondition(object.id)"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
            class="expand-feather"
          /> {{ $t('DEBTIA_EXPAND') }}
        </b-button>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 17 && object.depends_on === moduleObjectId"
        title="Bailiff Conclusion Popup"
        class="nested-condition-module nested-module"
      >
        <b-button
          variant="relief-primary"
          class="expand-btn"
          @click="expandCondition(object.id)"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
            class="expand-feather"
          /> {{ $t('DEBTIA_EXPAND') }}
        </b-button>
      </app-collapse-item>
      <app-collapse-item
        v-if="(object.module_id === 3 || object.module_id === 4) && object.depends_on === moduleObjectId"
        :title="object.module_id === 3 ? `Send Letter: ${object.module_settings.letter_template_title}` : `Send Email: ${object.module_settings.email_template_title}`"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                <b-row>
                  <b-col
                    v-for="variable in object.module_settings.custom_variables"
                    :key="variable.id"
                    cols="12"
                    md="12"
                    class="group-col"
                  >
                    <b-form-group
                      :label="variable.custom_variable"
                      label-for="h-first-name"
                      label-cols-md="12"
                      class="process-group"
                    >
                      <label>
                        {{ variable.mapped_value === 'letter_sent_date' ? `letter_sent_date (${variable.letter_order})` : variable.mapped_value }}
                        <ul v-if="variable.mapped_value === 'Conditional Mappable'">
                          <li><b>Condition:</b> {{ variable.condition.condition }}</li>
                          <li v-if="variable.condition.field !== null"><b>{{ variable.condition.field.label }}:</b> {{ variable.condition.field.value }}</li>
                          <li v-if="variable.condition.custom_variable_value !== null"><b> Custom Variable Value:</b> {{ variable.condition.custom_variable_value }}</li>
                          <li v-if="variable.condition.condition === 'Statements'"><b> Statements:</b> {{ variable.condition.statements }}</li>
                          <li><b>Operator:</b> {{ variable.condition.operator }}</li>
                          <li><b>Value if True:</b> {{ variable.condition.true_value }}</li>
                          <li><b>Value if False:</b> {{ variable.condition.false_value }}</li>
                        </ul>
                        <ul v-else-if="variable.mapped_value === 'letter_sent_date' && variable.letters.length > 0">
                          <li
                            v-for="(letter, index) in variable.letters"
                            :key="index"
                          >{{ letter }}</li>
                        </ul>
                      </label>
                    </b-form-group>
                  </b-col>
                </b-row>

              </b-list-group-item>

              <b-list-group-item
                v-if="
                  object.module_id === 3 &&
                    object.module_settings &&
                    object.module_settings.enabled_days
                "
              >
                <b>{{ $t('DEBTIA_SEND_DAYS') }}</b>
                {{ formattedDays(object.module_settings.enabled_days) }}
              </b-list-group-item>

            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="(object.module_id === 5 || object.module_id === 6) && object.depends_on === moduleObjectId"
        :title="object.module_id === 5 ? 'Change State Module' : 'Action Module'"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ object.module_id === 5 ? 'Process' : 'Action' }}: {{ object.module_id === 5 ? getState(object.module_settings.new_process_id) : getReason(object.module_settings.reason_id) }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <b-list-group
        v-if="object.module_id === 7 && object.depends_on === moduleObjectId"
        class="nested-module"
      >
        <b-list-group-item class="reminder-list-item">
          {{ 'Reminder Fee: '+object.module_settings.reminder_fee+' DKK' }}</b-list-group-item>
      </b-list-group>
      <app-collapse-item
        v-if="object.module_id === 8 && object.depends_on === moduleObjectId"
        title="Send Invoice Module"
        class="nested-condition-module nested-module"
      >
        <b-list-group
          flush
          class="awaitlist"
        >
          <b-list-group-item>
            {{ $t('DEBTIA_RECIPIENT') }} : {{ object.module_settings.recipient }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_AWAIT_PAYMENT ') }} : {{ object.module_settings.await_payment ? "True" : "False" }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_VATAMOUNT ') }} : {{ object.module_settings.vat_amount }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_SUBTOTAL ') }} : {{ object.module_settings.subtotal }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_TOTAL ') }} : {{ object.module_settings.total }}
          </b-list-group-item>
        </b-list-group>
        <h4>Products</h4>
        <b-table
          :items="object.module_settings.get_products"
          :fields="fields"
          striped
          responsive
          class="mb-0"
        >
          <template #cell(name)="row">
            {{ row.product_name }}
          </template>
          <template #cell(show_details)="row">

            <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
            <b-form-checkbox
              v-model="row.detailsShowing"
              @change="row.toggleDetails"
            >
              {{ row.detailsShowing ? $t('DEBTIA_HIDE') : $t('DEBTIA_SHOW') }}
            </b-form-checkbox>
          </template>

          <!-- full detail on click -->
          <template #row-details="row">
            <b-card>
              <b-row class="mb-2">
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>{{ $t('DEBTIA_QUANTITY') }} : </strong> {{ row.quantity }}
                </b-col>
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>{{ $t('DEBTIA_UNIT_PRICE') }} : </strong> {{ row.unit_price }}
                </b-col>
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>{{ $t('DEBTIA_TOTAL_PRICE') }} : </strong> {{ row.total_price }}
                </b-col>
              </b-row>
            </b-card>
          </template>

          <template #cell(avatar)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 9 && object.depends_on === moduleObjectId"
        title="User Action Module"
        class="nested-condition-module nested-module"
      >
        <b-list-group
          flush
          class="awaitlist"
        >
          <b-list-group-item>
            {{ $t('DEBTIA_DESCRIPTION') }} : {{ object.module_settings.description }}
          </b-list-group-item>
          <b-list-group-item
            v-if="object.module_settings.await"
          >
            {{ $t('DEBTIA_WAIT_FOR') }} : {{ object.module_settings.await_days }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_RECIPIENT') }} : {{ object.module_settings.recipient }}
          </b-list-group-item>
        </b-list-group>
        <b-button
          variant="relief-primary"
          class="expand-btn"
          @click="expandCondition(object.id)"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
            class="expand-feather"
          /> {{ $t('DEBTIA_EXPAND') }}
        </b-button>
      </app-collapse-item>

      <app-collapse-item
        v-if="object.module_id === 10 && object.depends_on === moduleObjectId"
        title="Task List Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_TASK_LIST') }} : {{ object.module_settings.title }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>

      <b-list-group
        v-if="object.module_id === 11 && object.depends_on === moduleObjectId"
        class="nested-module"
      >
        <b-list-group-item class="reminder-list-item">
          A Compensation Fee of 310 per Invoice Document will be charged.
        </b-list-group-item>
      </b-list-group>

      <b-list-group
        v-if="object.module_id === 12 && object.depends_on === moduleObjectId"
        class="nested-module"
      >
        <b-list-group-item class="reminder-list-item">
          Collection Cost will be auto calculated.
        </b-list-group-item>
      </b-list-group>
      <b-list-group
        v-if="object.module_id === 13 && object.depends_on === moduleObjectId"
        class="nested-module"
      >
        <b-list-group-item class="reminder-list-item">
          {{ 'Collection Fee: '+object.module_settings.collection_fee+' DKK' }}</b-list-group-item>
      </b-list-group>
      <app-collapse-item
        v-if="object.module_id === 15 && object.depends_on === moduleObjectId"
        title="Custom Field Data Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                <b-row>
                  <b-col
                    v-for="variable in object.module_settings"
                    :key="variable.id"
                    cols="12"
                    md="12"
                    class="group-col"
                  >
                    <b-form-group
                      :label="$t(variable.label)"
                      label-for="h-first-name"
                      label-cols-md="12"
                      class="process-group"
                    >
                      <label>{{ variable.value === 'dato_felt' ? getDatoFelto(variable.functional_value) : variable.value }}</label>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 16 && object.depends_on === moduleObjectId"
        title="Change Termsheet Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_APPLY_TERMSHEET_TO') }} : {{ object.module_settings ? object.module_settings.termsheet_for : 'N/A' }}
              </b-list-group-item>
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_TERMSHEET') }} : {{ object.module_settings ? object.module_settings.termsheet : 'N/A' }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 18 && object.depends_on === moduleObjectId"
        title="Bailiff Case Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_OPERATOR') }} : {{ object.module_settings ?
                  object.module_settings.bailiff_status === 1 ? "True" : "False"
                  : 'N/A' }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 19 && object.depends_on === moduleObjectId"
        title="Transfer Court Fee Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ object.module_settings.court }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 20 && object.depends_on === moduleObjectId"
        title="Register Debtor RKI Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ object.module_settings.message }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 21 && object.depends_on === moduleObjectId"
        title="Delete Debtor RKI Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_REASON') }}: {{ getDebtiaReason(object.module_settings.reason) }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 23 && object.depends_on === moduleObjectId"
        title="Overvagning Termsheet Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ object.module_settings.message }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 24 && object.depends_on === moduleObjectId"
        title="Await Till Date"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item class="internal-items">
                {{ $t('DEBTIA_QUESTION') }}: {{ object.module_settings.question }}
              </b-list-group-item>
              <b-list-group-item class="internal-items">
                {{ $t('DEBTIA_DESCRIPTION') }}: {{ object.module_settings.description }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 26 && object.depends_on === moduleObjectId"
        title="Deactivate Installment Plan Module"
        class="nested-module"
      >
        <b-list-group
          class="nested-module"
        >
          <b-list-group-item class="reminder-list-item">
            Active Installment Plan will be deactivated.
          </b-list-group-item>
        </b-list-group>
      </app-collapse-item>
    </app-collapse>
  </div>
  <div v-else>
    <app-collapse
      accordion
    >
      {{ $t('DEBTIA_NO_MODULE_MSG') }}
    </app-collapse>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BAlert, BListGroup, BListGroupItem, BFormGroup, BTable, BFormCheckbox,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'
// import i18n from '@/libs/i18n'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
// import AddModuleModal from './AddModuleModal.vue'

const DEBTIA_REASON_DESCRIPTIONS = {
  BET: 'Fordring betalt',
  AIN: 'Aftale indgået med skyldner',
  DØD: 'Skyldner er afgået ved døden',
  TFY: 'Tvangsakkord fyldestgjort',
  GAL: 'Gældssanering – al gæld bortfalder',
  VTT: 'Varen taget retur',
  TAF: 'Tvangsauktion aflyst',
  STR: 'Der er strid i sagen',
  DER: 'Andet – vi ønsker skyldner slettet',
}

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BAlert,
    BListGroup,
    BListGroupItem,
    AppCollapse,
    AppCollapseItem,
    BFormGroup,
    BTable,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    modulesObject: {
      type: Array,
      required: true,
    },
    moduleObjectId: {
      type: Number,
      required: true,
    },
    mainDivId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // conditionLoader: false,
      // previousObject: {},
      noObject: [],
      yesObject: [],
      allModules: [],
      stateNumber: 0,
      module: 0,
      modalLoaderOne: true,
      componentConditionCheck: false,
      conditionModule: true,
      processes: [],
      caseReasonOptions: [],
      fields: ['name', 'show_details'],
      userType: JSON.parse(localStorage.getItem('userData')).role[0],
      conditionOptions: [],
      loader: true,
    }
  },
  watch: {
    state: {
      handler() {
        this.stateNumber = this.state
      },
    },
  },
  created() {
    this.getProcesses()
    this.getConditions()
    this.getCaseReasonOptions()
  },
  methods: {
    async getProcesses() {
      const url = '/process/list?perPage=100000000&q=&page='
      await axios.get(url).then(response => {
        if (response.status) {
          const records = response.data.data.processes.data
          records.forEach(element => {
            const elementObj = { label: element.title, value: element.id }
            this.processes.push(elementObj)
          })
        }
      })
    },
    getConditionStatement(id) {
      const conditionTitle = this.conditionOptions.filter(element => element.value === id)
      return conditionTitle[0].label
    },
    expandCondition(id) {
      // this.conditionLoader = true
      // if (type === 2) {
      const obj = {
        btnId: id,
        main: this.mainDivId,
      }
      EventBus.$emit('expandDetailsInConditionModule', obj)
      // } else {
      // EventBus.$emit('expandDetailsInUserActionModule', id)
      // }
      // this.stateNumber += 1
      // setTimeout(() => {
      // const md = this.allModules
      // md.forEach(element => {
      //   if (element.id === id) {
      //     this.moduleObject = element
      //     if (this.moduleObject.depends_on === 0) {
      //       this.stateNumber = 0
      //     }
      //   }
      // })
      // this.getNoObject()
      // this.getYesObject()
      // this.conditionLoader = false
      // }, 3000)
    },
    getState(id) {
      let processTitle = ''
      processTitle = this.processes.filter(entry => entry.value === id)
      return processTitle[0].label
    },
    getReason(id) {
      let reasonTitle = ''
      reasonTitle = this.caseReasonOptions.filter(entry => entry.value === id)
      return reasonTitle[0].label
    },
    getDebtiaReason(code) {
      const description = DEBTIA_REASON_DESCRIPTIONS[code]
      return description ? `${code} - ${description}` : code
    },
    getDatoFelto(number) {
      // eslint-disable-next-line no-nested-ternary
      return Number(number) === 0 ? 'dags dato' : (Number(number) >= 1 ? `dags dato (+${number} dage)` : `dags dato (${number} dage)`)
    },
    async getConditions() {
      this.loader = true
      await axios.get('/process/get-conditions').then(response => {
        if (response.status === 200) {
          this.conditionOptions.push(...response.data.data.variables)
          this.loader = false
        }
      }).catch(error => console.log(error))
    },
    async getCaseReasonOptions() {
      const url = '/get-reason-options'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseReasonOptions = response.data.data
        }
      })
    },
    formattedDays(enabledDays) {
      if (!enabledDays) return ''

      // If "all" is true → return full week
      if (enabledDays.all) {
        return [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ].join(', ')
      }

      const daysMap = {
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thur: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Sunday',
      }

      return Object.keys(daysMap)
        .filter(day => enabledDays[day])
        .map(day => daysMap[day])
        .join(', ')
    },
  },
}
</script>

<style lang="scss">
.awaitlist {
  border-radius: 10px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  margin-bottom: 15px;
}

.row-yes-no {
  margin-top: 5px;
}

.yes-no {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}

.split-div .list-group-item.yes-no{
  background-color: #badcdc;
}

.split-div{
  border-radius: 5px;
  border-top: 2px solid #468783;
}

.yes-no:hover {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}
.list-group-item.main-items {
  text-align: center;
}

.condition-heading-title h4 {
  font-weight: 600;
  font-size: 1.1rem;
  color: inherit;
}

.collapse-icon.collapse-default .card .card-header {
  background-color: #f7f7f7;
}

.nested-condition-module {
  border: 1px solid #e4f2f1;
}

.nested-module {
  margin-bottom: 5px !important;
}

.expand-btn {
  width: 100%;
  margin-top: 10px;
}

.expand-feather {
  top: 0px !important;
}
.main-cols .alert .operator-list{
  position: relative;
  margin-bottom: 5rem;
  border-bottom: 2px solid #468783;
}

.list-group-item.internal-items {
  text-align: center;
}

.reminder-list-item {
  background-color: #f7f7f7;
}

</style>
